import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/supplier-add',
      name: 'admin-supplier-add',
      component: () => import(/* webpackChunkName: "page-admin-supplier-management-supplier-add" */ `./1.0.2/index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "添加供应商"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "供应商管理"
                                        },
                                        {
                                                  name: "添加供应商"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
